'use client';

import { useState } from 'react';
import Image from '@src/components/atoms/safe-image';

// Components
import SkeletonLoader from '@src/components/atoms/skeleton-loader';

// Assets
const Century21AwsS3Storage = `${process.env.NEXT_PUBLIC_AWS_S3_URL}/production.storages/storages/store/century-21-indonesia/a9c183f222b84f123b9106ef649e3504a04087e9.png`;

const Hero = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className="mt-0 mb-0 mx-auto py-[24px] w-full max-w-[1376px]
      dd3-2xl:max-w-[unset] dd2-2xl:px-[64px]
      dd3-xl:px-[40px]
      dd3-lg:px-[32px]
      dd3-md:px-[24px]"
    >
      <div className="rounded-xs flex bg-[#F4F2EB] 
      dd3-xl:flex-col">
        <div
          className="flex-1 gap-[32px] flex flex-col justify-center p-[32px]
          dd3-xl:p-[24px] dd3-xl:gap-1"
        >
          <h1
            className="font-satoshi-bold text-[#141415] text-[52px] leading-[62px] tracking-[-2.08px]
            dd3-xl:text-[33px] dd3-xl:leading-[39.6px] dd3-xl:tracking-[-0.99px] dd3-xl:mb-1
            dd3-md:text-[33px] dd3-md:leading-[39.6px] dd3-md:tracking-[-0.99px]"
          >
            Smarter, Bolder, Faster, Always Elevate
          </h1>
          <p
            className="font-satoshi max-w-[540px] text-[#686A68] text-[17px]/[23.8px] tracking-[-0.17px] 
          dd3-xl:text-[14px]"
          >
            Tumbuh bersama budaya yang mengutamakan inovasi, keandalan, dan
            peluang berkembang yang jelas. Raih kesuksesan karir Anda bersama
            CENTURY 21 Indonesia.
          </p>
        </div>

        <div
          className="relative flex-1 h-[380px] 
       dd3-3xl:h-[317px]
       dd3-2xl:h-[258px]
       dd3-xl:h-[395px]
       dd3-lg:h-[332px]
       dd3-md:h-[161px]"
        >
          <Image
            src={Century21AwsS3Storage}
            alt="Karir CENTURY 21 Indonesia"
            width={1000}
            height={1000}
            className="w-full h-full object-cover aspect-[217/122]"
            onLoad={() => setLoaded(true)}
          />
          <SkeletonLoader
            isShow={!loaded}
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
